import { Typography } from "@mui/material";
import { useMobile } from "../hooks/usemobile";
import { FileNameComponent } from "../pages/ApprovedDocuments";
import TenantUtils from "../util/tenant.utils";

export function PhotosGrid({photos,documentHandler,title}){
  const isMobile = useMobile();
  return photos?.length > 0 ? (
                        <>
                        {title && <h1 style={{fontWeight:'bold',padding:"8px"}}>{title}</h1>}
                        <div
                            style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fill, minmax(350px,1fr))',
                            gap: '16px',
                            marginTop: '12px',
                            padding:"8px"
                            }}
                        >
                            {photos.map((file, idx) => {
                            const fileName =
                                typeof file === 'string' ? file.split('/').pop() : file.name;

                            const url =
                                typeof file === 'string'
                                ? process.env.REACT_APP_FILE_SERVER + '/clientfiles/' + fileName
                                : URL.createObjectURL(file);

                            // return (
                            //     <div
                            //     key={`${fileName}-${idx}`}
                            //     style={{
                            //         display: 'flex',
                            //         flexDirection: 'column',
                            //         alignItems: 'center',
                            //         textAlign: 'center'
                            //     }}
                            //     >
                            //     <img
                            //         src={url}
                            //         alt={fileName}
                            //         style={{
                            //         width: '50%',
                            //         height: '75px',
                            //         objectFit: 'cover',
                            //         borderRadius: '4px',
                            //         border: '1px solid #ddd'
                            //         }}
                            //     />
                            //    { !isMobile ? <FileNameComponent label={fileName} documentUrl={url} documentTitle={fileName} serverUrl={url} onClick={documentHandler}/>
                            //    :
                            //     <a
                            //         href={url}
                            //         target="_blank"
                            //         rel="noopener noreferrer"
                            //         style={{
                            //         fontWeight: 'bold',
                            //         color: '#007bff',
                            //         textDecoration: 'underline',
                            //         marginTop: '6px',
                            //         overflowWrap: 'anywhere'
                            //         }}
                            //     >
                            //         {fileName}
                            //     </a>}
                            //     </div>
                            // );

                            return (<div
  key={`${fileName}-${idx}`}
  className="flex flex-col items-center text-center bg-white shadow-md rounded-xl p-4 hover:shadow-lg transition-shadow duration-200 border border-gray-100"
>
  <img
    src={url}
    alt={fileName}
    className="w-1/2 h-[75px] object-cover rounded-md border border-gray-200"
  />

  {!isMobile ? (
    <FileNameComponent
      label={fileName}
      documentUrl={url}
      documentTitle={fileName}
      serverUrl={url}
      onClick={documentHandler}
    />
  ) : (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="font-semibold text-blue-600 underline mt-2 break-words"
    >
      {fileName}
    </a>
  )}
</div>
)
                            })}
                        </div>
                        </>
                    ) : TenantUtils.isNavexel() ? <Typography sx={{fontFamily:"Figtree",fontWeight:"bold",textTransform:"capitalize",textAlign:"center",paddingY:"10px"}}>No Documents Found</Typography> : <></>
}